import React from 'react'

const Historyandculture = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Match the words with their meanings.</p>
        <p>Brevity ------ lasting only for a short time</p>
        <p>Conquest ------ victory over a place or people by use of military force</p>
        <p>Resemblance ------ the state of being alike</p>
        <p>Barbarian ------ a member of an uncivilized group of people of culture</p>
        <p>Ally ------ one state united to another by a treaty or a league for a military purpose</p>
        <p>Nobility ------ state of being noble in character, quality, or rank</p>
        <p>Ruthlessness ------ character of having no pity or compassion</p>
        <p>Decimation ------ the killing or destruction of a large number of a population</p>
        <p>Harsh ------ cruel</p>
        <p>Elixir ------ liquid that is believed to cure all ills</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Find the following words in the text and use them in sentences of your own.</p>
        <strong>Invasion</strong>
        <p>The sudden invasion of personal privacy through social media can make people feel unsafe.</p>
        <strong>Disregard</strong>
        <p>He showed complete disregard for the rules by sharing someone's private information online.</p>
        <strong>Paramount</strong>
        <p>Ensuring the safety of children online is of paramount importance in today's digital world.</p>
        <strong>Populace</strong>
        <p>The government launched a campaign to educate the populace about the dangers of cyberbullying.</p>
        <strong>Revolt</strong>
        <p>The students began to revolt against cyberbullying by raising awareness and reporting online abuse.</p>
        <strong>Assassination</strong>
        <p>The news reported the assassination of a political leader, which shocked the entire nation.</p>
        <strong>Serfdom</strong>
        <p>During medieval times, many peasants lived under serfdom, working on land owned by nobles.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>D. Consult a dictionary and prepare a list of ten homographs.</p>
        <strong>Bass </strong>
        <p>A low, deep sound / A type of fish.</p>
        <strong>Bat</strong>
        <p>A flying mammal / A wooden stick used in sports like cricket or baseball.</p>
        <strong>Evening</strong>
        <p>The part of the day between late afternoon and night / To make something level or equal</p>
        <strong>Bear</strong>
        <p>To carry or support something / A large wild animal with thick fur.</p>
        <strong>Close</strong>
        <p>To shut something / Near in distance or relationship.</p>
        <strong>Lean</strong>
        <p>To rest against or incline / Thin or having little fat.</p>
        <strong>Bow</strong>
        <p>To bend forward as a sign of respect / A weapon used to shoot arrows.</p>
        <strong>Lead</strong>
        <p>To guide or be in charge / A heavy, soft metal used in pipes and batteries.</p>
        <strong>Skip</strong>
        <p>To jump lightly or move with a springy step / To leave out or omit something.</p>
        <strong>Fair </strong>
        <p>Just, honest, and equal treatment / A public event with rides, games, and entertainment.</p>
    </div>
    <hr/>
    <div>
        <h3>Comprehension</h3>
        <p className='question'>B. Answer these questions.</p>
        <p className='question'>a. Why is the Zhou Age called a feudal age?</p>
        <p>= The Zhou Age is called a feudal age because Zhou period had followed the rule of feudalism.</p>
        <p className='question'>b. What is the location advantage of the Qin?</p>
        <p>= The location advantage of Qin is the territory or area of dynasty is well bounded by mountains.</p>
        <p className='question'>c. What contributed to the success in the warfare as described in the text?</p>
        <p>= The location of the state, their size of the army, and their expert use of the chariot contributed to their success in warfare.</p>
        <p className='question'>d. Why did the Qin invite the foreign advisor, Shang Yang?</p>
        <p>= The Qin invited the foreign advisor, Shang Yang due to the lack of intellectual peoples in Qin.</p>
        <p className='question'>e. What were the key features of the Qin political system?</p>
        <p>= The key features of the Qin political system were fear and control.</p>
        <p className='question'>f. How were the people treated during the Qin Period?</p>
        <p>= The people were treated almost like slave in that period. People were supposed to contribute in all projects for welfare of Nation and were deprived from the approach of education.</p>
        <p className='question'>g. Why did Shi Huangdi stop educating ordinary people?</p>
        <p>= Shi Huangdi stopped educating ordinary people because he believed that illiterate people can be controlled easily.</p>
        <p className='question'>h. What did the Qin achieve by the legalism in practice?</p>
        <p>= The Qin achieved superior army, disciplined populace, obedient peoples, the great wall, great canal etc. by the help of legalism.</p>
        <p className='question'>i. Why did Shi Huangdi never sleep in the same room for two consecutive nights?</p>
        <p>= Shi Huangdi never slept in the same room for two consecutive nights because of constant fear of assassination.</p>
        <p className='question'>j. What are the everlasting marks of the Qin Dynasty?</p>
        <p>= The everlasting marks of the Qin Dynasty are as follows:</p>
        <p>1. The Terracotta Army</p>
        <p>2. Concept of Legalism</p>
        <p>3. The Great Wall of China</p>
        <p>4. The Grand Canal</p>
        <p>5. Roads.</p>
    </div>
    <hr/>
    <div>
      <h3>Critical thinking</h3>
      <p className='question'>a. The Great Wall and the Taj Mahal are the creation of the autocratic rulers. Present your view for or against this statement.</p>
      <p>= I agree that the Great Wall of China and the Taj Mahal were created by autocratic rulers. The Great Wall of China was constructed primarily to protect the northern borders of the Chinese empire from enemy invasions. It is a massive structure made up of multiple walls built over centuries, with the earliest walls dating back to the 7th century BC. Such a huge project could not have been completed without the power of an autocratic ruler. People were often forced into labor under harsh punishments if they disobeyed orders. Those who contributed greatly were rewarded, but many were treated as slaves and suffered greatly during the construction.</p>
      <p>Similarly, the Taj Mahal was built by the Mughal Emperor Shah Jahan in memory of his wife Mumtaz Mahal. It is said that Shah Jahan ruled with an iron fist, reportedly harming the artists to ensure that the monument would remain unique. The construction took 20 years and involved around 20,000 workers. While many admire the beauty of the Taj Mahal, the harsh realities behind its construction often go unnoticed.</p>
      <p>In conclusion, both the Great Wall and the Taj Mahal are monumental creations made possible by the absolute power and control of autocratic rulers, who used their authority to mobilize resources and people, often at great human cost.</p>
    </div>
    <hr/>
    <div>
      <p className='question'>b. How do you describe the pros and cons of feudalism?</p>
      <p>= Feudalism was a social and economic system that dominated medieval Europe, where land was exchanged for service and protection. Under this system, peasants and knights served nobles or lords, who in turn provided land and security.</p>
      <p>One of the main advantages of feudalism was that it brought stability during a chaotic time. After the fall of the Roman Empire, Europe faced constant invasions and conflicts. Feudalism created a structured society where lords protected their lands and people from outside threats. It also encouraged loyalty and a sense of duty among knights and peasants, promoting bravery and honor. The system helped organize society and maintain order in the absence of a strong central government.</p>
      <p>However, feudalism had significant drawbacks. It reinforced social inequality by dividing people into strict classes, where the nobles had most of the power and wealth while peasants lived in hardship. Many peasants, known as serfs, were bound to the land and could not leave without their lord's permission. This lack of freedom and harsh control limited their opportunities and kept them dependent. Additionally, the system allowed lords to exploit their power, sometimes treating peasants unfairly without consequences.</p>
      <p>In summary, while feudalism provided protection and social order during difficult times, it also created divisions and restricted the freedom of many people, making life hard for the lower classes.</p>
    </div>
    <hr/>
    <div>
        <h3>Writing</h3>
        <p className='question'>a. Write an email to your friend living abroad stating the contributions of Prithvi Narayan Shah in the unification of Nepal.</p>
        <p>To: mansi03@gmail.com</p>
        <p>
From: ganesh18@gmail.com</p><p>
Subject: The Role of Prithvi Narayan Shah in Unifying Nepal
</p><p>
Dear Mansi,
</p><p>
I hope you are doing well. I wanted to share some important insights about Prithvi Narayan Shah and his crucial role in unifying Nepal, following our recent chat about Nepal's history.
</p><p>
Prithvi Narayan Shah was a great leader who ended the continuous fighting among the small kingdoms such as Kathmandu, Lalitpur, Bhaktapur, and Gorkha. Before his time, these states were divided and vulnerable to outside invasions. Shah's vision and courage brought these separate kingdoms together to form a single, united Nepal.
</p><p>
More than just a conqueror, he worked hard to create a sense of unity and patriotism among the people. His leadership protected Nepal from foreign domination and laid the groundwork for the country's independence. Unlike many rulers who ruled for their own benefit, Shah's focus was on the strength and welfare of the entire nation.
</p><p>
In summary, Prithvi Narayan Shah's contributions helped shape Nepal into the proud and independent country we know today. His legacy continues to inspire us all.
</p><p>
Looking forward for your thoughts!
</p><p>
Best wishes,
</p><p>
Ganesh</p>
    </div>
    <hr/>
    <div>
        <h3>Grammar</h3>
        <p className='question'>B. Complete the texts below using the correct past forms of the verbs from the bracket.</p>
        <p>a. The Maya established a very advanced civilisation in the jungles of the Yucatan. However, their culture <u>disappeared</u> (disappear) by the time Europeans first <u>arrived</u> (arrive) in the New World.</p>
        <p>b. When I <u>turned</u> (turn) on the radio yesterday, I <u>heard</u> (hear) a song that was popular when I <u>was</u> (be) at the basic level of my study. It <u>took</u> (take) me back to some old memories.</p>
        <p>c. I was looking for a job. I <u>applied</u> (apply) for a job last week. Fortunately, I <u>got</u> (get) it and now I am a job holder.</p>
    </div>
    <hr/>
    <div>
        <p className='question'>C. Choose the correct words from the list and complete the sentences with the correct verb form.</p>
        <p>a. Newton <strong>saw</strong> an apple falling from the tree.</p>
        <p>b. Ramesh Bikal <strong>wrote</strong> many popular stories.</p>
        <p>c. My jacket is expensive. It <strong>cost</strong> me Rs 5000.</p>
        <p>d. She <u>got up</u> early in the morning yesterday.</p>
        <p>e. When I was small, my father <strong>taught</strong> me at home.</p>
        <p>f. Why did you <strong>throw</strong> the cap away?</p>
    </div>
    <hr/>
    <div>
        <p className='question'>D. Put the verb into the correct form and complete the sentences.</p>
        <p>a. I went to see the film, but I <u>did not</u> it. (not/enjoy)</p>
        <p>b. I <u>met</u> Rojina in town in a few days ago. (meet)</p>
        <p>c. It was very warm, so I <u>took off</u> my coat. (take off)</p>
        <p>d. Though the bed was very comfortable, I <u>didn't sleep</u> very well. (not/sleep)</p>
        <p>e. I <u>started</u> new job last week. (start)</p>
        <p>g. He <u>was</u> too busy in the office yesterday. (be)</p>
        <p>h. Nita <u>invited</u> her to the party, but she didn't come. (invite)</p>
    </div>
    </div>
  )
}

export default Historyandculture
